import { Grid } from "@material-ui/core";
import { PublishedComponent } from "@openimis/fe-core";
import React from "react";

const ChangedHealthFacilityReport = (props) => {
  const { values, setValues } = props;

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <PublishedComponent
          pubRef="core.DatePicker"
          value={values.date_from}
          module="insuree"
          required
          label="dateFrom"
          onChange={(date_from) => setValues({ ...values, date_from })}
        />
      </Grid>
      <Grid item>
        <PublishedComponent
          pubRef="core.DatePicker"
          value={values.date_to}
          module="insuree"
          required
          label="dateTo"
          onChange={(date_to) => setValues({ ...values, date_to })}
        />
      </Grid>
    </Grid>
  );
};

export default ChangedHealthFacilityReport;
